export default "__VITE_ASSET__BtUvly0e__"